import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

import './panelists.scss';

// import required modules
import { Navigation, Pagination } from 'swiper/modules';
// import { WidthContext } from '../../WidthContext';
import Panelist from './Panelist';
import { panelistData } from './panelistData';

const SwiperCarousel = () => {
  return (
    <Swiper
      slidesPerView={1}
      slidesPerGroup={1}
      spaceBetween={0}
      navigation={true}
      cssMode={true}
      pagination={{
        el: '#pagination-container',
        clickable: true
      }}
      modules={[Pagination, Navigation]}
      breakpoints={{
        1025: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        1441: {
          slidesPerView: 3
        }
      }}
      className="panelists__carousel"
    >
      <div id="pagination-container"></div>

      {panelistData.map((data, i) => (
        <SwiperSlide className="panelists__item" key={`panelist-${i}`}>
          <Panelist data={data} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default SwiperCarousel;
